import { createContext } from 'react';
import { FilterExpandContainerContextProps } from './filter-expand-container.props';

export const FilterExpandContainerContext = createContext<FilterExpandContainerContextProps>({
  abbreviatedLength: 7,
  isFilterExpanded: false,
  setIsFilterExpanded: () => console.error('Function setIsExpandedFilter is not exist in FilterExpandContainerContext.')
});
